import axios, { AxiosResponse } from 'axios';
import { VALIDATE_EMAIL_CODE } from './endpoints';
import { Token } from '../models/Token';

export type ValidateEmailCodeParams = {
  token: Token;
};

export type ValidateEmailCodeResponse = {
  isValid: boolean;
};

export const validateToken = (
  token: Token,
  sourceContext: string | null,
): Promise<boolean> => {
  return axios
    .post<
      ValidateEmailCodeResponse,
      AxiosResponse<ValidateEmailCodeResponse>,
      ValidateEmailCodeParams
    >(
      VALIDATE_EMAIL_CODE,
      {
        token,
      },
      {
        headers: {
          'Source-Context': sourceContext,
        },
      },
    )
    .then((response) => response.data.isValid);
};
